module.exports = __webpack_public_path__ + "img/page9img4.5d370a93.png";